// import { Dropdown } from "../../../components/dropdown/Dropdown";
// import FieldsTree from "../../../components/FieldsTree";
import { useCallback, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AnalysisLayout from "../AnalysisLayout";
import QueryAttributes from "./QueryAttributes";
import QueryCubes from "./QueryCubes";
import QueryMeasures from "./QueryMeasures";
import QueryResult, { MyRefHandle } from "./QueryResult";
import { useEffect } from "react";
import {
  addNewMetaState,
  cloneMetaState,
  getMetadata,
  removeMetaState,
} from "../../../redux/queryMetaSlice";
import { AppDispatch, RootState } from "../../../redux/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "../../../components/button/IconButton";
import {
  faChevronLeft,
  faChevronRight,
  faRefresh,
  faRemove,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import {
  faClone,
  faFolderOpen,
  faPlusSquare,
  faTrashCan,
} from "@fortawesome/free-regular-svg-icons";
import { Button } from "../../../components/button/Button";
import {
  resultQuery,
  setupQuery,
  setIsQueryUpdated,
  setQuery,
  setLoadQueryMode,
  selectCurrentTab,
  tabsData,
  addNewTab,
  newQuery,
  changeTab,
  cloneTab,
  removeTab,
  setIsUpdatedTab,
  setAllTabUpdated,
  setQueryMode,
  setQuerySubType,
  setLoading,
  setSavingQuery,
  changeTabName,
} from "../../../redux/queryBuilderSlice";
import { useModal } from "../../../components/Modal";
import SavePopup from "./SavePopup";
import ExportAllPopup from "./ExportAllPopup";
import ToolTip from "../../../components/ToolTip";
import {
  Result,
  SavedQueryGroup,
} from "../../../interfaces/queryBuilderInterfaces";
import {
  addNewQueryId,
  removeQueryId,
  saveQueryIds,
  setSavedQueryName,
  setSavePopUpTitle,
  updateExistingQuery,
} from "../../../redux/saveSlice";
import { showNotification } from "../../../redux/notificationSlice";
import { AgGridReact } from "ag-grid-react";
import { arraysEqual } from "../../../utils/util";
import {
  addNewMapQuery,
  cloneMapQuery,
  getMapResult,
  removeMapquery,
  setMapLoading,
} from "../../../redux/mapSlice";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { getTheme } from "../../../redux/themeSlice";
import TooltipWrapper from "../../../components/TooltipWrapper";
import { getReportOptions } from "../../../redux/subscribeSlice";
import { selectMapQuery } from "./mapSelectors";
import LoadingOverlay from "../../../components/LoadingOverlay";

const TAB_NAME_MAX_LENGTH = 30;
type PanelTab = "displayFields" | "namedSet";


const QueryBuilder = (props: any) => {
  const gridRef = useRef<AgGridReact<Result>>(null);
    const [activePanelTab, setActivePanelTab] =
      useState<PanelTab>("displayFields");
  const theme = useSelector(getTheme);
  const queryResultRef = useRef<MyRefHandle>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [isLeftPanelExpanded, setIsLeftPanelExpanded] = useState(true);
  const [editingTabIndex, setEditingTabIndex] = useState<number | null>(null);
  const [editingTabName, setEditingTabName] = useState("");
  const [tabNameError, setTabNameError] = useState<string | null>(null);
  const tabInputRef = useRef<HTMLInputElement>(null);
  const [loadedGroupQueryId, setLoadedGroupQueryId] = useState();
  const [loadedQueryId, setLoadedQueryId] = useState();
  const [isOwnerOfQuery, setOwnerOfQuery] = useState(true);
  const [initialLoading, setIsInitialLoading] = useState(false);

  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const queryName = useSelector(
    (state: RootState) => state.save.savedQueryName,
  );
  // const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [confirmPopUp, setConfirmPopUp] = useState<any>({
    title: "",
    message: null,
    confirmAction: (title: string, id: number) => {},
    closeAction: () => {},
    id: 0,
  });
  const currentTabIndex = useSelector(
    (state: any) => state.queryBuilder.currentTabIndex,
  );

  // useEffect(()=> {
  //   setCurrentTabIndex(currIndex);
  // },[currIndex])

  const currTabData = useSelector(selectCurrentTab);
  const queries = useSelector((state: any) => state.queryBuilder.queries);
  const mapQueries = useSelector((state: any) => state.map.mapQueries);
  const isLoadingSavedQueries = useSelector(
    (state: any) => state.queryBuilder.isLoadingSavedQueries,
  );
  const isGridLoading = useSelector((state: RootState) => currTabData.loading);
  const { loading: isMapLoading } = useSelector((state: any) =>
    selectMapQuery(state, currentTabIndex),
  );

    const updatedNamedsetList = useSelector(
    (state: RootState) => currTabData.updatedNamedsetList,
  );
  const tabs = useSelector(tabsData);
  const toggleLeftPanelVisibility = () => {
    setIsLeftPanelExpanded((prevState) => !prevState);
  };
  const hoverText = isLeftPanelExpanded ? "Collapse" : "Expand";

  const query = useSelector((state: RootState) => currTabData.query);
  const isUpdatedTab = useSelector(
    (state: RootState) => currTabData.isUpdatedTab,
  );

  const currentQueryIndex = useSelector(
    (state: RootState) => currTabData.currentQueryIndex,
  );

  const isSavingQuery = useSelector(
    (state: RootState) => currTabData.isSavingQuery,
  );
  const currentUser = useSelector((state: RootState) => state.user.user.name);
  const currentQueryName =
    queryName?.length > 0 && queryName[currentTabIndex]
      ? queryName[currentTabIndex]
      : "New Query";
  const sharedQueryOwner = query?.owner;
  const isSharedQuery = Boolean(
    sharedQueryOwner && sharedQueryOwner !== currentUser,
  );
  const queryMode =
    useSelector((state: RootState) => currTabData.queryMode) ?? "Grid";

  const runQuery = () => {
    if (query) {
      dispatch(setupQuery({ payload: query, index: currentTabIndex })).then(
        async () => {
          dispatch(setLoadQueryMode({ flag: false, currentTabIndex }));
          dispatch(setIsUpdatedTab({ flag: true, currentTabIndex }));
          // if (queryMode !== "Map") {
          dispatch(
            resultQuery({
              query,
              queryMode,
              querySubType,
              index: currentTabIndex,
            }),
          );
          // } else {
          // dispatch(
          //   getMapResult({ selectedMap: querySubType, currentTabIndex })
          // );
          // }
        },
      );
    }
  };
  const queryId = useSelector((state: any) => state.save.queryId);
  const queryIds = useSelector((state: any) => state.save.queryIds);
  const groupId = useSelector((state: any) => state.save.groupId);

  useEffect(() => {
    setLoadedGroupQueryId(groupId);
  }, [dispatch, groupId]);

  useEffect(() => {
    setLoadedQueryId(queryIds);
  }, [dispatch, queryIds]);

  const selectedCube = useSelector(
    (state: any) => state.meta.metaStates[currentTabIndex]?.selectedCube,
  );
  useEffect(() => {
    setActivePanelTab("displayFields");
  }, [dispatch, selectedCube, currentTabIndex]);
  useEffect(() => {
    if (selectedCube && query?.cubeName !== selectedCube.name) {
      const connection = selectedCube?.connection;
      const catalog = selectedCube?.catalog;
      const schema = selectedCube?.schema;
      const cube = selectedCube?.name;
      dispatch(
        getMetadata({
          connection,
          catalog,
          schema,
          cube,
          currentTabIndex: currentTabIndex,
        }),
      );
    }
  }, [dispatch, selectedCube, currentTabIndex]);
  const querySubType =
    useSelector((state: RootState) => currTabData.querySubType) ?? "";
  const msrSelections =
    useSelector((state: RootState) => currTabData.msrSelections) ?? [];
  const openSaveModal = useModal(<SavePopup />);
  const openExportAllModal = useModal(<ExportAllPopup />);
  const saveClickHandler = async (saveAs: boolean) => {
    const rows: any[] = [];
    gridRef.current?.api?.getColumnDefs()?.forEach((col: any) => {
      if (query?.axes.ROWS.indexOf(col.levelUniqueName) !== -1) {
        rows.push(col.levelUniqueName);
      }
    });
    if (
      gridRef.current &&
      gridRef.current.api &&
      gridRef.current.api.getDisplayedRowCount() > 0 &&
      query != null &&
      query.axes &&
      !arraysEqual(query.axes.ROWS, rows) &&
      queryMode != "Map"
    ) {
      const updatedQuery = {
        ...query,
        axes: {
          ...query.axes,
          // ROWS: rows,
        },
      };
      // dispatch(
      //   setupQuery({ payload: updatedQuery, index: currentTabIndex }),
      // ).then(() => {
        saveQuery(saveAs);
        // dispatch(setQuery({ query: updatedQuery, currentTabIndex }));

        // if (queryMode !== "Map") {
        //   dispatch(
        //     resultQuery({
        //       query,
        //       queryMode,
        //       querySubType,
        //       index: currentTabIndex,
        //     }),
        //   );
        // } else {
        //   dispatch(
        //     getMapResult({ selectedMap: querySubType, currentTabIndex }),
        //   );
        // }
      // });
    } else {
      saveQuery(saveAs);
    }
  };

  const saveQuery = async (saveAs: boolean) => {
    if (!saveAs && loadedGroupQueryId && query) {
      dispatch(setSavingQuery({ flag: true, currentTabIndex }));

      const payload: SavedQueryGroup = {
        savedQueryList:
          tabs?.length > 0
            ? tabs.map((tab: any, index: number) => {
                return {
                  olapQueryName: tab.queryName,
                  name: tab.tabName,
                  description: "",
                  queryId: (loadedQueryId && loadedQueryId[index]) || null,
                  isShared: false,
                  isFlattenedView: false,
                  type: tab.queryMode,
                  subType: tab.querySubType,
                  gridSorts: tab.gridSorts,
                  ...(tab.queryMode === "Map" && {
                    mapOptions: { measureSelections: tab.msrSelections },
                  }),
                };
              })
            : [],
        // savedQueryList: [{
        // 	olapQueryName: query.name, name: "Tab1", description: "",
        // 	queryId: loadedQueryId,
        // 	isShared: false, isFlattenedView: false, type: queryMode, subType: querySubType,
        // 	gridSorts: query.gridSorts,
        // 	...(queryMode === 'Map' && { mapOptions: { measureSelections: msrSelections } })
        // }],
        name: "",
        description: "",
      };
      payload.id = loadedGroupQueryId;
      const result = await dispatch(updateExistingQuery(payload));
      if (result.payload === true) {
        dispatch(setAllTabUpdated());
        const queryData: any = await dispatch(
          getReportOptions(loadedGroupQueryId),
        );
        if (
          queryData.type === "reportOptions/fulfilled" &&
          queryData.payload &&
          queryData.payload.length > 0
        ) {
          let newQueryIds = queryData.payload.map((item: any) => item.key);
          dispatch(saveQueryIds(newQueryIds));
        }
        dispatch(setSavingQuery({ flag: false, currentTabIndex }));

        dispatch(
          showNotification({
            message: "Query saved successfully",
            duration: 3000,
          }),
        );
        dispatch(setIsQueryUpdated({ flag: false, currentTabIndex }));
      } else {
        dispatch(setSavingQuery({ flag: false, currentTabIndex }));

        dispatch(
          showNotification({
            message: "Error while saving query",
            duration: 3000,
            isError: true,
          }),
        );
      }
    } else {
      dispatch(setSavePopUpTitle(saveAs ? "Save As" : "Save New"));
      openSaveModal();
    }
  };

  const flattenedResults = useSelector(
    (state: RootState) => currTabData.results,
  );
  const [queryUpdated, setQueryUpdated] = useState(false);
  const hasUpdatedNamedSetInEnhancedFilter = useMemo(() => {
    if (
      !query?.enhancedFilterCriteria ||
      !updatedNamedsetList ||
      typeof updatedNamedsetList !== "object" ||
      Array.isArray(updatedNamedsetList)
    ) {
      return false;
    }

    return Object.entries(updatedNamedsetList).some(
      ([filterFieldUniqueName, namedSets]) => {
        if (!Array.isArray(namedSets) || namedSets.length === 0) {
          return false;
        }

        const fieldFilters = query.enhancedFilterCriteria?.[filterFieldUniqueName];
        if (!Array.isArray(fieldFilters)) {
          return false;
        }

        const normalizedNamedSets = new Set(
          namedSets.map((name: any) => String(name ?? "").trim().toLowerCase()),
        );

        return fieldFilters.some(
          (filterCategory: any) =>
            Array.isArray(filterCategory?.criteria) &&
            filterCategory.criteria.some(
              (criterion: any) =>
                Array.isArray(criterion?.values) &&
                criterion.values.some((value: any) => {
                  if (value?.namedSet !== true) {
                    return false;
                  }
                  const filterValue = String(value?.value ?? "")
                    .trim()
                    .toLowerCase();
                  return normalizedNamedSets.has(filterValue);
                }),
            ),
        );
      },
    );
  }, [updatedNamedsetList, query?.enhancedFilterCriteria]);

  const areEqual = (a: any, b: any) => {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    return JSON.stringify([...a].sort()) === JSON.stringify([...b].sort());
  };

  const sortQueryFilter = (filter: any, sortKey: string = "value") => {
    return filter.map((f: any) => {
      return {
        ...f,
        criteria: f.criteria.map((criterion: any) => {
          return {
            ...criterion,
            values: [...criterion.values].sort((a: any, b: any) =>
              a[sortKey].localeCompare(b[sortKey]),
            ),
          };
        }),
      };
    });
  };
  const prevTabIndexRef = useRef(currentTabIndex);
  useEffect(() => {
    const tabIndexChanged = prevTabIndexRef.current !== currentTabIndex;

    if (!tabIndexChanged && !(currentTabIndex == 0 && tabsData.length == 1)) {
      prevTabIndexRef.current = currentTabIndex;
      return;
    }
    if (query && flattenedResults) {
      const axesCheck = Object.keys(query?.axes || {}).every((key) => {
        const queryAxis = query?.axes[key as keyof typeof query.axes];
        const flattenedAxis =
          flattenedResults?.query?.axes[key as keyof typeof query.axes];
        return areEqual(queryAxis, flattenedAxis);
      });

      const enhancedFilterCheck = (() => {
        const queryKeys = Object.keys(query?.enhancedFilterCriteria || {});
        const flattenedKeys = Object.keys(
          flattenedResults?.query?.enhancedFilterCriteria || {},
        );
        // Check if key sets are equal
        if (
          queryKeys.length !== flattenedKeys.length ||
          !areEqual(queryKeys, flattenedKeys)
        ) {
          return false;
        }
        // Compare for matching keys
        return queryKeys.every((key) => {
          const queryFilter = query?.enhancedFilterCriteria[key];
          const flattenedFilter =
            flattenedResults?.query?.enhancedFilterCriteria[key];

          const queryFilterSort = sortQueryFilter(queryFilter);
          const flattenedFilterSort = sortQueryFilter(flattenedFilter);

          // Compare the key-value lists
          return areEqual(queryFilterSort, flattenedFilterSort);
        });
      })();
      const flag = !(axesCheck && enhancedFilterCheck);
      setQueryUpdated(flag);
      if (flag) {
        dispatch(setIsQueryUpdated({ flag, currentTabIndex }));
      }
    }
  }, [
    query?.axes,
    query?.enhancedFilterCriteria,
    flattenedResults?.query?.axes,
    flattenedResults?.query?.enhancedFilterCriteria,
  ]);

  const handleCloneTab = async () => {
    if (isGridLoading) {
      return;
    }
    if (selectedCube) {
      let currQuery = query;
      const currQuerymode = queryMode;
      const currSubQueryMode = querySubType;

      if (tabs.length == 10) {
        // dispatch(
        //   showNotification({
        //     message: "Tab limit exceeded. Maximum allowed is 10 tabs.",
        //     duration: 3000,
        //     isError: true,
        //   })
        // );
        return;
      }
      let newIndex = tabs.length;
      dispatch(cloneTab(null));
      dispatch(cloneMapQuery(currentTabIndex));

      dispatch(cloneMetaState(currentTabIndex));
      dispatch(addNewQueryId());
      if (selectedCube) {
        const formData = new FormData();
        formData.append("connection", selectedCube.connection);
        formData.append("cube", selectedCube.name);
        formData.append("catalog", selectedCube.catalog);
        formData.append("schema", selectedCube.schema);

        dispatch(newQuery({ formData, index: newIndex })).then((query: any) => {
          if (query.type === "olapquery/new/fulfilled") {
            currQuery = {
              ...currQuery,
              name: query.payload.name,
            };

            dispatch(setupQuery({ payload: currQuery, index: newIndex })).then(
              (query: any) => {
                dispatch(
                  setQueryMode({ type: currQuerymode, currentTabIndex }),
                );
                dispatch(
                  setQuerySubType({ type: currSubQueryMode, currentTabIndex }),
                );
                dispatch(
                  setLoading({ flag: false, currentTabIndex: newIndex }),
                );
                //         if(currQuerymode == "Map") {
                //           dispatch(getMapResult({ selectedMap: currSubQueryMode, currentTabIndex:currentTabIndex })
                //         );
                //         }else {
                dispatch(
                  resultQuery({
                    query: query.payload,
                    queryMode: currQuerymode,
                    querySubType: currSubQueryMode,
                    index: newIndex,
                  }),
                );

                //         }
              },
            );
          }
        });
      }
      // dispatch(cloneTab(false));
    }
  };
  const handleNewTab = () => {
    if (selectedCube) {
      if (tabs.length == 10) {
        // dispatch(
        //   showNotification({
        //     message: "Tab limit exceeded. Maximum allowed is 10 tabs.",
        //     duration: 3000,
        //     isError: true,
        //   })
        // );
        return;
      }
      dispatch(addNewTab(null));
      dispatch(addNewMapQuery());
      dispatch(addNewMetaState());
      dispatch(addNewQueryId());
      // if (selectedCube) {
      //   const formData = new FormData();
      //   formData.append("connection", selectedCube.connection);
      //   formData.append("cube", selectedCube.name);
      //   formData.append("catalog", selectedCube.catalog);
      //   formData.append("schema", selectedCube.schema);
      //   dispatch(newQuery({formData,index:currentTabIndex})).then((query: any) => {
      //     dispatch(setupQuery({payload:query.payload,index:currentTabIndex})).then((query: any) => {

      //       dispatch(resultQuery({ query: query.payload, index:currentTabIndex }));
      //     });
      //   });
      // }
    }
  };

  const handleDeleteTab = (tabName: string, index: number) => {
    setShowConfirmPopup(true);
    setConfirmPopUp({
      title: "Delete Tab",
      message: (
        <>
          {" "}
          Do you want to delete{" "}
          <span
            style={{ color: theme.palette.primary.main, fontStyle: "italic" }}
          >
            {tabName}
          </span>{" "}
          ?
        </>
      ),
      confirmAction: (title: string, id: number) => {
        dispatch(removeTab(index));
        dispatch(removeMapquery(index));

        dispatch(removeMetaState(index));

        dispatch(removeQueryId(index));
        setShowConfirmPopup(false);
      },
      closeAction: () => {
        setShowConfirmPopup(false);
      },
      id: currentTabIndex,
    });
  };
  useEffect(() => {
    setOwnerOfQuery(query?.owner === undefined || query.owner === currentUser);
  }, [query?.owner]);

  const startEditingTab = useCallback((index: number, currentName: string) => {
    setEditingTabIndex(index);
    setEditingTabName(currentName);
    setTabNameError(null);
    setTimeout(() => tabInputRef.current?.select(), 0);
  }, []);

  const commitTabRename = useCallback(() => {
    if (editingTabIndex === null) return;
    const trimmed = editingTabName.trim();
    if (!trimmed) {
      setTabNameError("Tab name cannot be empty");
      tabInputRef.current?.focus();
      return;
    }
    if (trimmed.length > TAB_NAME_MAX_LENGTH) {
      setTabNameError(
        `Tab name cannot exceed ${TAB_NAME_MAX_LENGTH} characters`,
      );
      tabInputRef.current?.focus();
      return;
    }
    const isDuplicate = tabs.some(
      (t: any, i: number) =>
        i !== editingTabIndex &&
        t.tabName.toLowerCase() === trimmed.toLowerCase(),
    );
    if (isDuplicate) {
      setTabNameError("Tab name already exists");
      tabInputRef.current?.focus();
      return;
    }
    if (trimmed !== tabs[editingTabIndex]?.tabName) {
      dispatch(changeTabName({ tabName: trimmed, index: editingTabIndex }));
    }
    setEditingTabIndex(null);
    setEditingTabName("");
    setTabNameError(null);
  }, [editingTabIndex, editingTabName, tabs, dispatch]);

  const cancelTabRename = useCallback(() => {
    setEditingTabIndex(null);
    setEditingTabName("");
    setTabNameError(null);
  }, []);

  return (
    <>
      <AnalysisLayout>
        <div className="query-builder-container">
          <div className={isLeftPanelExpanded ? "left-panel-container" : ""}>
            <div
              className={
                isLeftPanelExpanded
                  ? "query-bar-header"
                  : "query-bar-header-rotated"
              }
            >
              {!isLeftPanelExpanded && (
                <div
                  className={
                    isLeftPanelExpanded ? "" : "query-bar-header-text-rotated"
                  }
                >
                  Edit Query
                </div>
              )}
              {isLeftPanelExpanded && (
                <div id="apply-filters" className="btns">
                  <Button
                    className="btn sm"
                    disabled={
                      !(queryUpdated || hasUpdatedNamedSetInEnhancedFilter) ||
                      isGridLoading ||
                      isMapLoading
                    }
                    color="primary"
                    onClick={() => {
                      // if (queryMode !== "Map") {
                      dispatch(setLoading({ flag: true, currentTabIndex }));

                      // }else {
                      //   dispatch(setMapLoading({flag:true,currentTabIndex}))

                      // }
                      runQuery();
                    }}
                  >
                    Run Query
                  </Button>
                </div>
              )}
              <div
                className={
                  isLeftPanelExpanded
                    ? "query-bar-header-button"
                    : "query-bar-header-button-rotated"
                }
              >
                <IconButton onClick={toggleLeftPanelVisibility}>
                  <span style={{ fontWeight: "normal" }}>
                    <ToolTip
                      icon={
                        isLeftPanelExpanded ? faChevronLeft : faChevronRight
                      }
                      message={hoverText}
                    />
                  </span>
                </IconButton>
              </div>
            </div>
            {isLeftPanelExpanded && (
              <div className="left-panel">
                <QueryCubes currentActiveTab={currentTabIndex} />
                <QueryMeasures currentActiveTab={currentTabIndex} />
                <QueryAttributes
                  currentActiveTab={currentTabIndex}
                  activePanelTab={activePanelTab}
                  setActivePanelTab={setActivePanelTab}
                />
              </div>
            )}
          </div>
          <div
            style={{
              width: "100%",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="tools-bar">
              <div
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  lineHeight: 1.2,
                  minWidth: 0,
                  maxWidth: "45%",
                }}
              >
                {isSharedQuery && (
                  <TooltipWrapper
                    iconPositionCenter={true}
                    position="top"
                    content={`Shared query | Owner: ${sharedQueryOwner}`}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: theme.palette.secondary.main,
                        flexShrink: 0,
                        width: 18,
                        height: 18,
                        borderRadius: 999,
                        backgroundColor: `${theme.palette.primary.main}20`,
                        cursor: "help",
                      }}
                      aria-label="Shared query"
                    >
                      <FontAwesomeIcon
                        icon={faShare}
                        style={{ fontSize: 11 }}
                      />
                    </span>
                  </TooltipWrapper>
                )}

                <span
                  title={currentQueryName}
                  style={{
                    display: "inline-block",
                    minWidth: 0,
                    flex: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {currentQueryName}
                </span>

                
              </div>

              <div className="right-btns">
                <Button
                  className="btn sm"
                  disabled={!isOwnerOfQuery || isGridLoading || isMapLoading}
                  color="primary"
                  variant="outline"
                  onClick={() => {
                    saveClickHandler(false);
                  }}
                >
                  SAVE
                </Button>
                <Button
                  className="btn sm"
                  disabled={isGridLoading || isMapLoading}
                  color="primary"
                  variant="outline"
                  onClick={() => {
                    saveClickHandler(true);
                  }}
                >
                  SAVE AS
                </Button>

                {tabs.length > 1 && (
                  <Button
                    className="btn sm"
                    style={{ minWidth: 120 }}
                    disabled={isGridLoading || isMapLoading || initialLoading}
                    color="primary"
                    // variant="outline"
                    onClick={() => {
                      queryResultRef?.current?.callResetAll();
                    }}
                  >
                    RESET ALL
                  </Button>
                )}
                {tabs.length > 1 && (
                  <Button
                    className="btn sm"
                    style={{ minWidth: 120 }}
                    disabled={isGridLoading || isMapLoading}
                    color="primary"
                    onClick={() => {
                      openExportAllModal();
                    }}
                  >
                    EXPORT ALL
                  </Button>
                )}
              </div>
            </div>
            <div
              className="tools-bar"
              style={{
                padding: "0px",
                alignItems: "flex-end",
                borderBottom: "none",
              }}
            >
              <div className="tabs-container">
                {tabs.map((tab: any, index: number) => {
                  const isActive = index === currentTabIndex;

                  return (
                    <div
                      key={index}
                      onClick={() => {
                        if (editingTabIndex === index) return;
                        if (isLoadingSavedQueries && index > 0) {
                          return;
                        } else {
                          dispatch(changeTab(index));
                        }
                      }}
                      onDoubleClick={(e) => {
                        e.stopPropagation();
                        if (!isLoadingSavedQueries || index === 0) {
                          startEditingTab(index, tab.tabName);
                        }
                      }}
                      className={`tab-item ${isActive ? "active" : ""} ${isLoadingSavedQueries && index > 0 ? "disabled" : ""}`}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          minWidth: 0,
                          position: "relative",
                        }}
                      >
                        {((queryIds[index] && !queries[index].isUpdatedTab) ||
                          (currentQueryIndex == 0 && queryIds[index])) && (
                          <div
                            style={{
                              width: 10,
                              height: 10,
                              backgroundColor: "green",
                              borderRadius: 5,
                              flexShrink: 0,
                            }}
                          ></div>
                        )}

                        {editingTabIndex === index ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              minWidth: 0,
                              alignItems: "flex-start",
                            }}
                          >
                            <input
                              ref={tabInputRef}
                              type="text"
                              value={editingTabName}
                              maxLength={TAB_NAME_MAX_LENGTH}
                              autoFocus
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => {
                                setEditingTabName(e.target.value);
                                if (tabNameError) setTabNameError(null);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  commitTabRename();
                                } else if (e.key === "Escape") {
                                  cancelTabRename();
                                }
                              }}
                              onBlur={commitTabRename}
                              style={{
                                border: `1px solid ${tabNameError ? theme.palette.primary.main : "#aaa"}`,
                                borderRadius: 3,
                                padding: "2px 4px",
                                outline: "none",
                                width: "100%",
                                minWidth: 40,
                                fontWeight: "normal",
                                color: theme.palette.primary.hover,
                                maxWidth: 140,
                                background: "transparent",
                                // color: 'inherit',
                              }}
                            />
                            {tabNameError && (
                              <span
                                style={{
                                  color: theme.palette.primary.main,
                                  fontSize: 10,
                                  lineHeight: 1.2,
                                  fontWeight: "normal",
                                  marginTop: 4,
                                  whiteSpace: "normal",
                                  maxWidth: 140,
                                }}
                              >
                                {tabNameError}
                              </span>
                            )}
                          </div>
                        ) : (
                          <span className="tab-label" title={tab.tabName}>
                            {tab.tabName}{" "}
                            {(!queryIds[index] ||
                              queries[index].isUpdatedTab) &&
                              !(currentQueryIndex == 0 && queryIds[index]) && (
                                <span style={{ fontSize: 16 }}>*</span>
                              )}
                          </span>
                        )}
                      </div>

                      {tabs.length > 1 && (
                        <FontAwesomeIcon
                          onClick={(e) => {
                            e.stopPropagation();
                            if (
                              !isGridLoading &&
                              !isMapLoading &&
                              !queries[index].loading &&
                              !mapQueries[index]?.loading &&
                              !initialLoading
                            ) {
                              handleDeleteTab(tab.tabName, index);
                            }
                          }}
                          size="2x"
                          icon={faTrashCan}
                          className="tab-delete"
                        />
                      )}
                    </div>
                  );
                })}

                <TooltipWrapper
                  iconPositionCenter={true}
                  position="top"
                  content={"Create New Tab"}
                >
                  <div
                    className="tab-item"
                    onClick={() => {
                      if (!isGridLoading && !isMapLoading && !initialLoading) {
                        handleNewTab();
                      }
                    }}
                  >
                    <IconButton
                      disabled={
                        !selectedCube ||
                        tabs.length >= 10 ||
                        isGridLoading ||
                        isMapLoading ||
                        initialLoading
                      }
                      onClick={() => {}}
                    >
                      <FontAwesomeIcon icon={faPlusSquare} />
                    </IconButton>
                  </div>
                </TooltipWrapper>

                <TooltipWrapper
                  iconPositionCenter={true}
                  position="top"
                  content={"Duplicate Tab"}
                >
                  <div
                    className="tab-item"
                    onClick={() => {
                      if (!isGridLoading && !isMapLoading && !initialLoading)
                        handleCloneTab();
                    }}
                  >
                    <IconButton
                      disabled={
                        !selectedCube ||
                        tabs.length >= 10 ||
                        isGridLoading ||
                        isMapLoading ||
                        initialLoading
                      }
                      onClick={() => {}}
                    >
                      <FontAwesomeIcon icon={faClone} />
                    </IconButton>
                  </div>
                </TooltipWrapper>
              </div>
            </div>
            <QueryResult
              initialLoading={initialLoading}
              setIsInitialLoading={setIsInitialLoading}
              ref={queryResultRef}
              setActivePanelTab={setActivePanelTab}
              currentActiveTab={currentTabIndex}
              gridRef={gridRef}
            />
          </div>
        </div>
        {showConfirmPopup && (
          <ConfirmPopup
            title={confirmPopUp.title}
            id={confirmPopUp.id}
            message={confirmPopUp.message}
            confirmAction={confirmPopUp.confirmAction}
            closeAction={confirmPopUp.closeAction}
          ></ConfirmPopup>
        )}
        <LoadingOverlay show={isSavingQuery} />
      </AnalysisLayout>
    </>
  );
};

export default QueryBuilder;
